import * as types from './types'

export const fetchActivations = () => ({ type: types.FETCH_ACTIVATIONS })
export const activationsFetchSent = () => ({ type: types.FETCH_ACTIVATIONS_SENT })
export const activationsFetchSuccess = activation => ({ type: types.FETCH_ACTIVATIONS_SUCCESS, activation })
export const activationsFetchFailed = () => ({ type: types.FETCH_ACTIVATIONS_FAILED })
export const portalActivateManuallySuccess = () => ({ type: types.PORTAL_ACTIVATE_MANUALLY_SUCCESS })
